import { useCurrentScreen } from '@auth0/auth0-acul-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Synchronizes the i18n language with the current transaction locale.
 * Defaults to 'fr' if no locale is found on the transaction.
 */
export const useTransactionLocale = () => {
  const { i18n } = useTranslation();
  const screen = useCurrentScreen();

  // Extract locale from the transaction, default to 'fr'
  const locale = screen?.transaction?.locale ?? 'fr';

  useEffect(() => {
    if (i18n.isInitialized && i18n.language !== locale) {
      i18n.changeLanguage(locale);
    }
  }, [locale, i18n, i18n.isInitialized]);

  return locale;
};
